export const checkCaps = (userCaps,curCap) =>{
	return userCaps?.capabilities.includes(curCap);
}
export const isAdmin = (roles) =>{
	return roles.includes('iems_super_admin');
}
export const checkPermissions = (userPermissions, allowedPermissions) => {
	if (allowedPermissions.length === 0) {
	  return true;
	}
	return userPermissions.some(permission =>
	  allowedPermissions.includes(permission)
	);
  };
  const CapsModules = ["Supplier","Demand","EoI","Users","Website"];
export const clubCapsModules = (caps_array = []) =>{
	let modulesCapsList = [];
	CapsModules.map((mclv, i)=>{
		modulesCapsList[i] = {module_name:`${mclv}`,capabilities:[]};
		caps_array.map((v)=>{
			if(v.capability.indexOf(mclv) > -1 ){
				modulesCapsList[i].capabilities.push(v);
			}
			return true;
		});
		return true;
	});
	return modulesCapsList;
}